import { Controller } from "@hotwired/stimulus";

/**
 * Part télécharger une url dès que l'élément apparaît — posé par le serveur sur le statut
 * « prêt » d'un export du plateau (jamais sur une page de suivi). L'url est un attachment :
 * la page reste en place. Une seule fois par export (key), même si le frame est rechargé
 * avec une url présignée différente. Émet `autodownload:done` dans les deux cas — le flash
 * qui porte la carte s'en sert pour se retirer.
 */
export default class extends Controller {
  static values = { url: String, key: String };

  connect() {
    const key = `autodownload:${this.keyValue}`;
    if (!sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, "1");
      window.location.assign(this.urlValue);
    }
    this.dispatch("done");
  }
}
